import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { colors } from "../theme/colors";
import OkyEbiLogo from "../assets/oky ebi logo.webp";
import OkyBiMallLogo from "../assets/newLine/logos-header-oky-mall-bi.png";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowBackIos } from "@mui/icons-material";

export default function Header() {
  const [infoPage, setinfoPage] = useState();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleInfoPage = () => {
    // !infoPage ? navigate("../info") : navigate(-1);
    // pathname === "/info" ? setinfoPage(true) : setinfoPage(false);

    !infoPage ? navigate("../info") : navigate("../");
    pathname === "/info" ? setinfoPage(true) : setinfoPage(false);
  };

  useEffect(() => {
    pathname === "/info" ? setinfoPage(true) : setinfoPage(false);
  }, [pathname]);

  return (
    <Box
      sx={{
        height: {
          xs: `${pathname.split("/")[1] === "shop" ? "250px" : "200px"}`,
          md: "200px",
        },
        backgroundColor: colors.primary,
      }}
    >
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item sm={1}></Grid>
        <Grid item sm={3}>
          <Grid
            container
            alignItems="center"
            sx={{ "&:hover": { cursor: "pointer", opacity: "0.5" } }}
            onClick={() => {
              window.scrollTo(0, 0);
              String(pathname).split("/")[1] === "shop"
                ? navigate("../")
                : navigate(-1);
            }}
            display={{
              xs: "none",
              md: pathname.split("/")[1] === "shop" ? "flex" : "none",
            }}
          >
            <ArrowBackIos color="secondary" />
            <Typography
              variant="body1"
              color="secondary"
              fontSize="24px"
              fontWeight="bold"
              paddingLeft="1rem"
            >
              Atrás
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          sm={4}
          style={{ textAlign: "center", marginTop: "1rem" }}
          onClick={() => navigate("../../")}
          sx={{ "&:hover": { cursor: "pointer" } }}
        >
          <img
            src={OkyBiMallLogo}
            alt="EcosistemasBi"
            style={{ maxWidth: "100%" }}
          />
        </Grid>
        <Grid item xs={0} sm={4} md={2}></Grid>
        <Grid
          item
          xs={6}
          sm={3}
          md={2}
          sx={{ paddingTop: "0 !important", textAlign: "center" }}
        >
          <Typography
            color={"white"}
            sx={{
              fontWeight: "bold",
              fontSize: "20",

              "&:hover": {
                color: colors.secondary,
                textDecoration: "underline",
                cursor: "pointer",
              },
            }}
            onClick={handleInfoPage}
          >
            {!infoPage ? "¿Cómo funciona?" : "Inicio"}
          </Typography>
        </Grid>
        {/* <Grid
          item
          xs={12}
          display={{
            xs: pathname.split("/")[1] === "shop" ? "flex" : "none",
            md: "none",
          }}
        >
          <ArrowBackIos color="secondary" />
          <Typography
            variant="body1"
            color="secondary"
            fontSize="16px"
            fontWeight="bold"
            paddingLeft="1rem"
          >
            Atrás
          </Typography>
        </Grid> */}
      </Grid>
    </Box>
  );
}
